var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"tel"},[_vm._v(" 服务热线："),_c('a',{on:{"click":_vm.service}},[_vm._v(_vm._s(_vm.zzconfig.PHONE))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }